import { BaseURl } from "./BaseApiUrl";

export const getEmpWorkingShiftsAPIURL = BaseURl + "userdetails/getUserTodaysWorkingShifts/v1/";